import { useState, useEffect, useCallback, useRef } from 'react';
import comercialComissaoService from 'features/comercial/services/comercialComissaoService';
import { getCompanyContext } from 'utils/setCompanyContext';

const ESTADO_VAZIO = {
  // `ativacao` até agosto/2026, `assinatura` de setembro em diante, `misto` quando o filtro cruza o
  // corte. Quem manda é a API — ver `ComissaoResposta::regime()`.
  regime: 'ativacao',
  kpis: {
    comissao_liquida_final: 0,
    comissao_vendas: 0,
    comissao_up_sell: 0,
    comissao_chip: 0,
    descontos_inadimplencia: 0,
    total_ativacoes: 0,
    ticket_medio: 0,
    novos_clientes: 0,
    total_negociacoes: 0,
    chips_vendidos: 0,
    qtd_up_sells: 0,
    receita_total: 0,
  },
  filtros: { vendedores: [], colaboradores: [], cidades: [] },
  ativacoes_tempo: [],
  top_cidades: [],
  clientes_nao_instalados: [],
  clientes_instalados: [],
  detalhamento_negociacoes: [],
  ranking_colaboradores: [],
  detalhamento_upsell: [],
  detalhamento_chip: [],
  inadimplentes: [],
};

const useComercialComissao = (filtroData = null, filtrosLocais = {}) => {
  const [dados, setDados] = useState(ESTADO_VAZIO);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);

  const carregandoRef = useRef(false);

  const carregarDados = useCallback(async (force = false) => {
    if (carregandoRef.current) return;
    carregandoRef.current = true;
    setLoading(true);
    setError(null);

    try {
      const ctx = getCompanyContext();
      const empresa = ctx?.companies?.[0]?.name || 'MOV Fibra';

      const params = {
        empresa,
        data_inicio: filtroData?.start,
        data_fim: filtroData?.end,
        vendedor: filtrosLocais.vendedor || '',
        colaborador: filtrosLocais.colaborador || '',
        cidade: filtrosLocais.cidade || '',
        eh_loja: !!filtrosLocais.eh_loja,
        _force: !!force,
      };

      const resultado = await comercialComissaoService.buscarDadosComissao(params);

      if (resultado.success && resultado.data) {
        setDados({ ...ESTADO_VAZIO, ...resultado.data });
        setUltimaAtualizacao(new Date());
      } else {
        setError(resultado.error || 'Falha ao carregar comissões');
        setDados(ESTADO_VAZIO);
      }
    } catch (err) {
      setError(err.message || 'Erro inesperado');
      setDados(ESTADO_VAZIO);
    } finally {
      setLoading(false);
      carregandoRef.current = false;
    }
  }, [filtroData?.start, filtroData?.end, filtrosLocais.vendedor, filtrosLocais.colaborador, filtrosLocais.cidade, filtrosLocais.eh_loja]);

  useEffect(() => {
    carregarDados();
  }, [carregarDados]);

  useEffect(() => {
    const handler = () => carregarDados();
    window.addEventListener('company-changed', handler);
    return () => window.removeEventListener('company-changed', handler);
  }, [carregarDados]);

  const recarregar = useCallback(() => carregarDados(true), [carregarDados]);

  return { dados, loading, error, ultimaAtualizacao, recarregar };
};

export default useComercialComissao;
